export default __webpack_public_path__ + "images/9S.27b6cba.png";